import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";

export default function ImmigrationMyFiles() {
  const nav = useNavigate();
  const [d, setD] = useState(null);

  useEffect(() => { api.get("/immigration/officer-dashboard").then(r=>setD(r.data)); }, []);
  if (!d) return <div className="text-slate-500">Loading…</div>;

  const cards = [
    ["New / Docs Pending", (d.counts["New File"]||0) + (d.counts["Documents Pending"]||0), "text-slate-700"],
    ["Documents Received", d.counts["Documents Received"]||0, "text-blue-600"],
    ["Preparing", d.counts["Preparing"]||0, "text-indigo-600"],
    ["Changes Required", d.counts["Changes Required"]||0, "text-rose-600"],
    ["Ready to Submit", d.counts["Approved for Submission"]||0, "text-emerald-600"],
    ["Submitted", d.counts["Submitted"]||0, "text-teal-600"],
    ["Doc Requests", d.counts["Documents Requested"]||0, "text-amber-600"],
    ["Approved", d.counts["Approved"]||0, "text-green-600"],
  ];

  const action = [
    ["🔴 Status Expiring ≤ 7 days", d.action_required.expiry_7, d.action_required_ids.expiry_7],
    ["🟠 Status Expiring ≤ 14 days", d.action_required.expiry_14, d.action_required_ids.expiry_14],
    ["🟡 Status Expiring ≤ 30 days", d.action_required.expiry_30, d.action_required_ids.expiry_30],
    ["📥 Doc Request Deadline ≤ 7d", d.action_required.docs_request_deadline, d.action_required_ids.docs_request_deadline],
    ["✏️ Changes Required", d.action_required.changes_required, d.action_required_ids.changes_required],
    ["✅ Ready to Submit", d.action_required.ready_to_submit, d.action_required_ids.ready_to_submit],
    ["💤 Untouched 14+ days", d.action_required.untouched_14d, d.action_required_ids.untouched_14d],
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="heading-font text-3xl font-bold text-slate-900">My Immigration Files</h1>
        <p className="text-sm text-slate-500 mt-1">{d.total} files assigned to you</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3">
        {cards.map(([label, val, cls]) => (
          <button key={label} onClick={()=>nav(`/immigration/applications?status=${encodeURIComponent(label)}`)}
                  className="bg-white rounded-xl border border-slate-200 p-4 text-left hover:shadow-md transition-shadow">
            <div className="text-xs uppercase text-slate-500">{label}</div>
            <div className={`heading-font text-2xl font-bold mt-1 ${cls}`}>{val}</div>
          </button>
        ))}
      </div>

      <div className="bg-white rounded-xl border border-slate-200">
        <div className="px-5 py-3 border-b border-slate-200 heading-font font-semibold">Action Required</div>
        <div className="divide-y divide-slate-100">
          {action.map(([label, count, ids]) => (
            <div key={label} className="flex items-center justify-between px-5 py-3">
              <div className="text-sm">{label}</div>
              <div className="flex items-center gap-3">
                <span className={`text-sm font-semibold ${count>0?"text-slate-900":"text-slate-400"}`}>{count}</span>
                {count > 0 && ids?.[0] && <Button size="sm" variant="outline" onClick={()=>nav(`/immigration/applications/${ids[0]}`)}>Open first</Button>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
